
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FileParameter, GroupUserExternal, MediaApiControllerUIClient, MediaItem } from '../../../backend/backendapi';
import { handleError, initClient } from '../../../../api';
import CameraModal from '../../../util/CameraModal.vue';

@Component({
  components: {
    CameraModal,
  },
})
export default class ExternalUserImageEditor extends Vue {
  @Prop({ default: false })
  readonly externalUser!: GroupUserExternal;

  private readonly api = initClient(MediaApiControllerUIClient);

  media: MediaItem | null = null;

  get uid(): string {
    return (this as any)._uid;
  }

  clearPicture(): void {
    this.externalUser.mediaId = undefined;
  }

  async saveMedia(event: { fileName: string, file: Blob }): Promise<void> {
    try {
      const media = await this.api.upload(null, null, [{ fileName: event.fileName, data: event.file } as FileParameter]);
      this.externalUser.mediaId = media.fileId;

      (this.$refs.cameraModal as CameraModal).dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }

  @Watch('externalUser.mediaId', { immediate: true })
  async onMediaIdChanged(): Promise<void> {
    this.media = null;
    if (!this.externalUser.mediaId) {
      return;
    }
    this.media = await this.api.get(this.externalUser.mediaId);
  }
}
